import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';

@Injectable({
    providedIn: 'root'
})
export class ChoiceGroupService extends ApiService {
    getAll() {
        return super.get('/choices-groups');
    }

    getById(id: number) {
        return super.get('/choices-groups/' + id);
    }

    getByKey(key: string) {
        return super.get('/choices-groups/key/' + key);
    }

    getMultipleByKeys(data: any) {
        return super.post('/choices-groups/keys', data);
    }

    create(data: any) {
        return super.post('/choices-groups/create', data);
    }

    update(data: any) {
        return super.put('/choices-groups/update', data);
    }

    delete(id: number) {
        return super.delete('/choices-groups/' + id);
    }
}
